/** Infographic — document knowledge definition. Pure data. */
export default {
  id: 'infographic',
  name: 'Infographic',
  description: 'A tall visual explainer that turns data and processes into a scannable story.',
  purpose: 'Data Storytelling & Education',
  recommendedSizes: [
    { name: 'Tall', width: 800, height: 2000, unit: 'px' },
    { name: 'A4', width: 2480, height: 3508, unit: 'px' },
  ],
  supportedOrientations: ['portrait'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: true,
  supportsPricing: false,
  supportsCTA: true,
  supportsOffers: false,
  supportsTimeline: true,
  supportsGallery: false,
  typicalSections: ['Title', 'Introduction', 'Data Blocks', 'Timeline', 'Sources', 'Footer'],
};
